module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_1.bdec7746.jpg";